import { render, staticRenderFns } from "./PlacementsStartComponentDevelopmentItemAction.vue?vue&type=template&id=011d3b9e&"
import script from "./PlacementsStartComponentDevelopmentItemAction.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponentDevelopmentItemAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports